<template>
  <component
    :is="tag"
    :class="{ 'has-cursor-wait': isProcessing }"
    :disabled="disabled || isProcessing"
    :loading="isProcessing"
    @click="processAction"
  >
    <slot />
  </component>
</template>

<script lang="ts">
import { defineComponent } from "vue";
import { useCProdInjector } from "@/composables/useCProdInjector";
import { useCProdProvInjector } from "@/composables/useCProdProvInjector";

export default defineComponent({
  name: "CProdActionControl",
  props: {
    tag: { type: String, default: "u-link" },
    action: { type: Function, default: () => {} },
    disabled: { type: Boolean, default: false }
  },
  setup() {
    const { cProdMethods } = useCProdInjector();
    const { cProdProvMethods } = useCProdProvInjector();
    return { cProdMethods, cProdProvMethods };
  },
  data: () => ({
    isProcessing: false
  }),
  methods: {
    async processAction() {
      try {
        this.isProcessing = true;
        await this.action({
          cProdMethods: this.cProdMethods,
          cProdProvMethods: this.cProdProvMethods
        });
      } finally {
        this.isProcessing = false;
      }
    }
  }
});
</script>
